import history from '../../history';
import {
    deleteContentPageMutation,
    getContentPageDetailsQuery,
    updateContentPageStatusMutation
} from '../../lib/graphql';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { setLoaderComplete, setLoaderStart } from '../loader/loader';

const deleteContentPageDetails = (id, currentPage) => {
    try {
        return async (dispatch, getState, { client }) => {

            try {
                const { data } = await client.mutate({
                    mutation: deleteContentPageMutation,
                    variables: { id },
                    refetchQueries: [{ query: getContentPageDetailsQuery, variables: { currentPage } }]
                });
                if (data?.deleteContentPage?.status === 200) {
                    showToaster({ messageId: 'deleteContentSuccess', toasterType: 'success' });
                    history.push('/siteadmin/contentpage/manage')
                    return {
                        status: 200
                    }
                }
                else if (data?.deleteContentPage?.status !== 200) {
                    showToaster({ messageId: 'errorMessage', requestContent: data?.deleteContentPage?.errorMessage, toasterType: 'error' });
                    return { status: 400 }
                } else {
                    showToaster({ messageId: 'errorMessage', toasterType: 'error' });
                    return { status: 400 }
                }
            } catch (error) {
                showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
                return { status: 400 }
            }
        }
    }
    catch (error) {
        showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
    }
}

const updateContentPageStatus = (id, isEnable, currentPage, refetch) => {
    try {
        return async (dispatch, getState, { client }) => {
            dispatch(setLoaderStart('updateContentStatusLoading'))

            const { data } = await client.mutate({
                mutation: updateContentPageStatusMutation,
                variables: { id, isEnable },
            });

            if (data?.updateContentPageStatus?.status === 200) {
                await refetch({ currentPage });

                dispatch(setLoaderComplete('updateContentStatusLoading'))
                showToaster({ messageId: 'updateStatusSuccess', toasterType: 'success' });
            }
            else if (data?.updateContentPageStatus?.status !== 200) {
                dispatch(setLoaderComplete('updateContentStatusLoading'))
                showToaster({ messageId: 'errorMessage', requestContent: data?.updateContentPageStatus?.errorMessage, toasterType: 'error' });
            }
            else {
                dispatch(setLoaderComplete('updateContentStatusLoading'));
                showToaster({ messageId: 'errorMessage', toasterType: 'error' });
            }
        }
    } catch (error) {
        dispatch(setLoaderComplete('updateContentStatusLoading'))
        showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
    }
}

export { deleteContentPageDetails, updateContentPageStatus }